<template>

    <div>

        <!-- page header -->
        <page-heading :show="true" pageTitle="CATALOG-ONLINE-NEW_PRODUCTS"></page-heading>

    	<!-- show loading indicator -->
    	<loading-indicator :loading="isLoading"></loading-indicator>

    	<template v-if="!isLoading">

			<div class="columns">

				<div class="col-main">

                    <div class="box">


                    </div>

                </div>

            </div>


        </template>

    </div>

</template>

<script>

export default {

	name: 'catalogOnlineNewProducts',

    data() {

		return {
            isLoading: false,

        }
    },


    created() {

        this.fetchData();

    },


    computed: {


    },

    methods: {

        fetchData() {

            this.isLoading = true;
            var self = this;

            self.isLoading = false;
            console.log("fetching data ... ");

        }

    }

}
</script>

<style>

</style>
